var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"page-style"}},[(!_vm.newsDetail)?_c('LogoLoading'):_c('div',[(_vm.newsDetail)?_c('NewDetail',{attrs:{"newsDetail":_vm.newsDetail,"categorie":_vm.categorieNews}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }